import { render, staticRenderFns } from "./PreviewV2.vue?vue&type=template&id=72cacf7c&"
import script from "./PreviewV2.vue?vue&type=script&lang=js&"
export * from "./PreviewV2.vue?vue&type=script&lang=js&"
import style0 from "./PreviewV2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports